module.exports = __webpack_public_path__ + "static/media/im8.ee1822ba.png";